import { gql } from '@apollo/client';

export const fetchInvoiceForOrderToCancel = gql`
  query fetchInvoiceForOrderToCancel($id: ID!) {
    invoiceForOrderToCancel(id: $id) {
      invoiceNumber
      createdDate
    }
  }
`;
